<template>
  <div class="widthContent">
    <PageBanner url="https://www.yueyilan.com/img-yueyilan/upload/photo/zsyf/jituan.png" title="集团部门"/>
    <router-view></router-view>
  </div>
</template>

<script>
import PageBanner from '@/components/PageBanner'
export default {
  name: 'index',
  components:{
    PageBanner
  }
}
</script>





// WEBPACK FOOTER //
// src/components/department/index.vue